ItemListPopOverComponent = require 'views/enterprise/dashboard/item-list-popover-component'
ListComponent = require 'views/enterprise/dashboard/list-component'
SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_popover')
_ = require('underscore')

COLLAPSED_LIST_LENGTH = 10

module.exports = class extends ItemListPopOverComponent
  constructor: (props) ->
    super(props)
    @state.groupItems = @_groupItems()

  _groupItems: ->
    groups =
      active: []
      deactivated: []

    for org in @props.itemList.items()
      group = if org.toBackbone()
        .getMembershipFor(@props.renderableMember)?.deactivated
          'deactivated'
        else
          'active'
      groups[group].push(org)
    groups

  _updateItemListState: (newItems) ->
    if @infiniteScroll && newItems
      @setState groupItems: @_groupItems()
    super(newItems)

  render: t.renderable ->
    t.div '.enterprise-pop-over', =>
      if @props.renderableMember.enterpriseOrgCount > COLLAPSED_LIST_LENGTH
        t.addElement React.createElement SearchComponent,
          onChange: @onSearchTermChange
          placeholder: t.l(['search', @props.modelName])
          searchCount: @props.renderableMember.enterpriseOrgCount
          debounce: true


      if @props.buttonData?
        t.addElement React.createElement @props.buttonData.componentClass,
          onClick: @props.buttonData.onClick

      if @state.items.length == 0
        t.addElement React.createElement ListComponent,
          items: @state.items
          loadingState: @state.loadingState
          itemComponent: @props.itemComponent
          isPopOver: true

      else
        for group, items of @state.groupItems when items.length > 0
          t.div =>
            t.h3 '.popover-group-header', ->
              t.format group

            t.addElement React.createElement ListComponent,
              items: items
              loadingState: @state.loadingState
              itemComponent: @props.itemComponent
              itemEventHandlers: @props.itemEventHandlers
              itemInlineButtons: @props.itemInlineButtons
              isPopOver: true



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/group-list-popover-component.coffee